import { MAX_BILLING_CONTACTS } from './billingContactModal.constants'

const messages = {
  addAnotherContact: 'Add another contact',
  atLeastOneRequired:
    'At least one billing contact is required. Add another before removing this one.',
  billingContactsSaveErrorDescription:
    'Something went wrong on our end and your changes were not saved. Please try again.',
  billingContactsSaveErrorTitle: "Couldn't save billing contacts",
  billingContactsSavedDescription:
    'Your invoice recipients have been updated successfully.',
  billingContactsSavedTitle: 'Billing contacts saved',
  cancel: 'Cancel',
  contactN: (number: number) => `Contact ${number}`,
  contactName: 'Contact Name',
  email: 'Email',
  emailAddress: 'Email Address',
  emailInUse: 'This email address is already in use.',
  invalidEmail: 'Please enter a valid email address.',
  lastUpdated: (date: string) => `Last updated on ${date}`,
  modalSubtitle:
    'Invoices are sent to the contacts below. Add up to 3. At least one contact is required.',
  modalTitle: 'Billing Contacts',
  name: 'Name',
  nOfMaxContactsAdded: (amount: number) =>
    `${amount} of ${MAX_BILLING_CONTACTS} contacts added`,
  pleaseFillInDetails: (plural: boolean) =>
    `Please fill in the details of the previous contact${plural ? 's' : ''}`,
  save: 'Save',
}

export default messages
